module.exports = __webpack_public_path__ + "img/kerstin_cv_3.c014c25a.jpg";